import {
  DEFAULT_RECORDING_MODES,
  RECORDING_MODES,
} from "../recordingModes";

const PRODUCT_PRESENTATION_RECORDING_MODE_FEATURE_KEYS = Object.freeze({
  [RECORDING_MODES.SPIROMETRY]: "spirometry",
  [RECORDING_MODES.TIDAL]: "cardiopulmonary",
  [RECORDING_MODES.PULSE]: "pulse",
  [RECORDING_MODES.POSTEXERTION]: "exertionRecovery",
  [RECORDING_MODES.SIX_MINUTE_WALK]: "sixMinuteWalk",
  [RECORDING_MODES.MAUDIO]: "manualAudio",
});

export function isRecordingModeEnabledForProductPresentationProfile(
  mode,
  productPresentationProfile,
) {
  const featureKey =
    PRODUCT_PRESENTATION_RECORDING_MODE_FEATURE_KEYS[String(mode || "").trim()] ||
    null;

  if (!featureKey) {
    return false;
  }

  if (!productPresentationProfile || typeof productPresentationProfile !== "object") {
    return true;
  }

  return Boolean(productPresentationProfile?.userWebApp?.modes?.[featureKey]);
}

export function filterRecordingModesForProductPresentationProfile(
  recordingModes,
  productPresentationProfile,
) {
  if (!Array.isArray(recordingModes)) {
    return [];
  }

  return Array.from(
    new Set(
      recordingModes.filter((mode) =>
        isRecordingModeEnabledForProductPresentationProfile(
          mode,
          productPresentationProfile,
        ),
      ),
    ),
  );
}

export function resolveDefaultRecordingModesForProductPresentationProfile(
  productPresentationProfile,
) {
  return filterRecordingModesForProductPresentationProfile(
    DEFAULT_RECORDING_MODES,
    productPresentationProfile,
  );
}
